<ion-card>
  <ion-card-header>
    <ion-card-title>
      <ion-text>
        {{ texts.material.title | translate }}
      </ion-text>
    </ion-card-title>
  </ion-card-header>
  <ion-card-content>
    <app-material-form
      #formElement
      [displaySettings]="formSettings">
    </app-material-form>
    <ion-button (click)="onSave()" class="ion-padding-top">
      <ion-label>{{ texts.general.save | translate }}</ion-label>
    </ion-button>
  </ion-card-content>
</ion-card>
